import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useInvitedUsers } from 'app/components/invited-users/useInvitedUsers'
import { InvitedUsersShadcnComponent } from 'app/components/invited-users/InvitedUsersShadcnComponent'
import { useManageUsersPageAccess } from 'app/hooks/useManageUsersPageAccess'

// observer: reads authStore.user via useUser() in render, so the component must be an observer.
const InvitedUsers = observer(function InvitedUsers(): React.ReactElement {
  const { me, isOrgUser, canEditUser } = useManageUsersPageAccess()
  const { invites, handleDelete } = useInvitedUsers()

  if (!me) return <></>

  if (!me.workspaceId) {
    return <Navigate to="/settings/users" replace />
  }

  const canManageUsers = me.type === `super` || isOrgUser || canEditUser
  if (!canManageUsers) {
    return <Navigate to="/settings/users/active" replace />
  }

  return (
    <InvitedUsersShadcnComponent
      invites={invites}
      canManageUsers={canManageUsers}
      canEditUser={canEditUser}
      onDelete={handleDelete}
    />
  )
})

export default InvitedUsers
